export default values => ({
  ...values,
  rfc: values.rfc || '',
  curp: values.curp || ''
});
